import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://d6dc5f8b0a1b562c76654fd223998e4d@o4506016597213184.ingest.us.sentry.io/4508609624801281',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
